import mitt from 'mitt';
import AxiosInstance from "../api/axios";

export const UserEventBus = mitt();

let eventAlreadyHandled = false;

const UserEventBusMixin = {
    created() {
        // Listen for success and error events
        UserEventBus.on('event-like', this.eventLiked);
        UserEventBus.on('un-event-like', this.eventUnLiked);
    },

    beforeUnmount() {
        // Remove the listeners when the component is destroyed
        UserEventBus.off('event-like', this.eventLiked);
        UserEventBus.off('un-event-like', this.eventUnLiked);
    },

    methods: {
        async eventLiked(EventId) {
            if (!eventAlreadyHandled) {
                // Set the flag to prevent multiple displays
                eventAlreadyHandled = true;

                const createLikeRequest = {
                    EventId,
                };

                try {
                    // Send the POST request
                    var response = await AxiosInstance.post("users/event/liked", createLikeRequest);

                    // Handle the successful response
                    console.log("Like request successful:", response.data);
                } catch (error) {
                    // Handle any errors
                    console.error("Error sending like request:", error.response?.data || error.message);
                }


                // Reset the flag after 3 seconds
                setTimeout(() => {
                    eventAlreadyHandled = false;
                }, 3000); // 3000 milliseconds = 3 seconds
            }
        },
        async eventUnLiked(EventId) {
            if (!eventAlreadyHandled) {
                // Set the flag to prevent multiple displays
                eventAlreadyHandled = true;

                var response = await AxiosInstance.delete("users/event" + EventId + "/liked");
                console.dir(response);

                // Reset the flag after 3 seconds
                setTimeout(() => {
                    eventAlreadyHandled = false;
                }, 3000); // 3000 milliseconds = 3 seconds
            }
        },
    },
};

export default UserEventBusMixin;
